export const SET_MONITOR_LIST = 'SET_MONITOR_LIST'
export const UPDATE_MONITOR_SETTINGS = 'UPDATE_MONITOR_SETTINGS'
export const UPDATE_MONITOR_NAME = 'UPDATE_MONITOR_NAME'
